export default ({ message, originalError = null }: any) => {
  const error = new Error(message);
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'originalError' does not exist on type 'E... Remove this comment to see the full error message
  error.originalError = originalError;
  return error;
};
